import React, { useState } from 'react'
import IconHeartFillCenterCard from '@/components/icons/IconHeartFillCenterCard/IconHeartFillCenterCard'
import IconHeartStrokeCenterCard from '@/components/icons/IconHeartStrokeCenterCard/IconHeartStrokeCenterCard'
import useSegment from '../../hooks/segment/useSegment'
import {
  updateFavoriteStorage,
  isFavorite
} from '@/domain/favoriteCenters/updateFavoriteStorage'

type FavoriteCenterHeartButtonCenterFeedProps = {
  isFavorite?: boolean
  centerId: number
  centerSlug: string
}

const FavoriteCenterHeartButtonCenterFeed: React.FC<
  FavoriteCenterHeartButtonCenterFeedProps
> = ({ isFavorite = false, centerId, centerSlug }) => {
  const [isFavoriteState, setIsFavoriteState] = useState(isFavorite)
  const [hasTracked, setHasTracked] = useState(false)
  const segment = useSegment()

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    if (!hasTracked) {
      const referrer = window.location.pathname

      segment.favoriteCenter.click({
        center_id: centerId,
        is_favorite: !isFavoriteState,
        referrer,
        center: centerSlug
      })
      setHasTracked(true)
    }
    updateFavoriteStorage({ centerId })
    setIsFavoriteState(!isFavoriteState)
  }

  return (
    <button
      onClick={handleFavoriteClick}
      aria-label={
        isFavoriteState ? 'Remove from favorites' : 'Add to favorites'
      }
      aria-pressed={isFavoriteState}
      type="button"
      className="flex items-center justify-center !bg-transparent p-[10px]"
    >
      {isFavoriteState ? (
        <IconHeartFillCenterCard className="size-6 text-gray-1100 transition-transform hover:scale-110" />
      ) : (
        <IconHeartStrokeCenterCard className="size-6 stroke-2 transition-transform hover:scale-110" />
      )}
    </button>
  )
}

export default FavoriteCenterHeartButtonCenterFeed
